<template>
  <form @submit.prevent="editShortlist">

    <div class="form-group double vanilla" :class="{'has-input-error': errors.label}">
      <label for="shortlist-label">Shortlist name</label>
      <input id="shortlist-label" type="text" name="label" v-model="shortlist.label" required/>
      <input-error v-if="errors.label">
        {{ errors.label[0] }}
      </input-error>
    </div>

    <div class="form-group vanilla submit">
      <loader-button
          type="submit"
          :loading="loading"
          label="Edit shortlist"
          class="button green block"
      ></loader-button>
    </div>

  </form>
</template>

<script>
import BaseModal from '../Base'

export default {
  extends: BaseModal,
  data () {
    return {
      shortlist: {
        label: this.data.label || ''
      },
      loading: false,
      errors: {}
    }
  },
  methods: {
    editShortlist () {
      this.loading = true
      axios.put(`/api/account/shortlists/${this.data.id}`, {
        label: this.shortlist.label
      })
          .then(response => {
            this.$store.commit('user/updateShortlists', response.data)
            this.$toasted.show('Your shortlist has been updated.', {
              type: 'success'
            })
            this.$emit('confirm', this.shortlist)
          })
          .catch(error => {
            this.$toasted.show('Your shortlist could not be updated, please review errors and try again.', {
              type: 'error'
            })
            this.errors = error.response.data.errors || {}
          })
          .then(() => {
            this.loading = false
          })
    }
  }
}
</script>
